import React, { useEffect, useRef } from "react";
import { Button, CartItem, DiscountProgressBar } from "~components";
import cn from "classnames";
import { useCartContext, useAppContext } from "~hooks";
import * as styles from "./styles.module.scss";
import CartUpsellCard from "../CartUpsellCard";

const CartContent = () => {
  const scrollContentRef = useRef(null);

  const { cartItems, checkout, goToCheckout, isCheckingOut, getCartPrice } =
    useCartContext();
  const { isCartOpen } = useAppContext();

  const { discounted, preDiscounted, isDiscounted } = getCartPrice();

  const displayPrice = isDiscounted
    ? discounted.toFixed(2)
    : preDiscounted.toFixed(2);
  const currencyCode = checkout?.paymentDue?.currencyCode;

  const strikethroughPrice = isDiscounted ? preDiscounted.toFixed(2) : null;

  const isCartEmpty = !cartItems?.[0];

  useEffect(() => {
    if (isCartOpen && !isCartEmpty) {
      scrollContentRef.current.scrollTo(0, 0);
    }
  }, [isCartOpen]);

  if (isCartEmpty) {
    return (
      <div className={styles.emptyCart}>
        <div className={cn(`h3`, styles.emptyText)}>Your cart is empty</div>
        <Button to="/products">Shop Now</Button>
      </div>
    );
  }

  return (
    <>
      <div className={styles.cartTop}>
        <DiscountProgressBar />
        <CartUpsellCard />
      </div>

      {/* Scroll content */}
      <div className={styles.scrollContent} ref={scrollContentRef}>
        <div className={styles.products}>
          {cartItems?.map(({ variantId, quantity }) => (
            <div className={styles.product} key={variantId}>
              <CartItem variantId={variantId} quantity={quantity} />
            </div>
          ))}
        </div>
      </div>
      {/* Bottom + checkout */}
      {!isCartEmpty && (
        <div className={styles.bottom}>
          <div className={styles.subtotal}>
            <div className="b1">Sub-Total</div>
            <div className="b1">
              ${displayPrice}
              {strikethroughPrice && (
                <span className={styles.strikethrough}>
                  ${strikethroughPrice}
                </span>
              )}
              <span className="caption">
                {` `}
                {currencyCode}
              </span>
            </div>
          </div>
          <div className={cn(`caption`, styles.bottomText)}>
            <span>Taxes and Shipping calculated at checkout.</span>
          </div>
          <Button fluid onClick={goToCheckout} loading={isCheckingOut}>
            Checkout
          </Button>
        </div>
      )}
    </>
  );
};

export default CartContent;
